import { z } from "zod";
import { env } from "../../env";
import {
  parseServiceInput,
  parseServiceOutput,
  requestConfig,
} from "../../globals";
import { type Wishlist, wishlist } from "../schemas/wishlist";

export const deleteWishlistTagProps = z
  .object({
    tag: z.number(),
    token: z.string(),
    deleteItems: z.boolean(),
  })
  .extend(requestConfig.shape);

export type DeleteWishlistTagProps = z.infer<typeof deleteWishlistTagProps>;

export const deleteWishlistTag = async (
  args: DeleteWishlistTagProps,
): Promise<Wishlist> => {
  const {
    endpoint = env.ACCOUNT_SERVICE_URL,
    tag,
    token,
    deleteItems,
    proxyAuthSecret,
  } = parseServiceInput(deleteWishlistTagProps, args);

  const headers = new Headers({
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
    ...(proxyAuthSecret && { "X-NG-Proxy-Auth": proxyAuthSecret }),
  });

  const response = await fetch(
    `${endpoint}/v3/wishlist/tag/${tag}/${Boolean(deleteItems)}`,
    {
      method: "DElETE",
      headers,
    },
  );

  return parseServiceOutput(response, wishlist, {
    code: "MALFORMED_WISHLIST",
    message: "Wishlist is malformed",
  });
};
